import { makeStyles } from '@material-ui/styles'
import { playerMobileHeight } from 'styling/theme'

export const interactionNavBarHeight = 48
export const interactionWidgetHeight = `calc(100vh - ${playerMobileHeight}vw - ${interactionNavBarHeight}px)`

export const useStyles = makeStyles(({ colors, typographyPresets }) => ({
    interactionWidget: {
        zIndex: 2,

        '@media (max-width: 767px)': {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: '1',
            position: 'relative',
        },
    },
    interactionWidgetContent: {
        backgroundColor: colors.dark.dark2,
        height: interactionWidgetHeight,
        overflow: 'scroll',

        '@media (min-width: 768px)': {
            height: '100%',
            overflow: 'initial',
            position: 'absolute',
            left: 0,
            top: 50,
            bottom: 0,
            right: 0,

            '@supports (height: initial)': {
                height: 'initial',
            },
        },
    },

    tvInteractionWidgetContent: {
        backgroundColor: colors.dark.dark2,
        height: '100%',
        overflow: 'scroll',

        '& > div': {
            maxWidth: '100%',
        },
    },

    title: {
        ...typographyPresets.titleSmallBold,
    },
}))
